module.exports = __webpack_public_path__ + "img/symbol_2.48e25ef8.png";